import React, { useMemo } from 'react';
import { Integration } from '../services/api/types';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import { IsRoyalMailOba } from './IsRoyalMailOba';

interface props {
  integration: Integration;
}

export default function IntegrationSpecificText(props: props) {
  const content = useMemo(() => {
    if (props.integration.accounts.find((x) => x.status == 'Submitted' && IsRoyalMailOba(props.integration))) {
      return 'RMOBA';
    }
    return '';
  }, []);

  switch (content) {
    case 'RMOBA':
      return (
        <P2GGrid item>
          <P2GText>
            We have received your request and submitted this to Royal Mail who will verify the connection. This is
            likely to take 2-5 working days. You will receive an update via email when this has been completed.
          </P2GText>
        </P2GGrid>
      );

    default:
      return null;
  }
}
